import axios from 'axios';
import { APP_CODE } from './appRelease';

const pendingRequests = new Map();

export function fetchAppRelease(platform) {
  const pendingRequest = pendingRequests.get(platform);
  if (pendingRequest) return pendingRequest;

  const request = axios.post(
    `${process.env.REACT_APP_SERVER_URL}/app/version`,
    { appCode: APP_CODE, platform },
    { timeout: 4000 }
  )
    .then((response) => response.data)
    .finally(() => pendingRequests.delete(platform));

  // Only share an active request. A later visit must check the current release.
  pendingRequests.set(platform, request);
  return request;
}
